export const getDate = state => state.date;
